import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import { enqueueSnackbar } from 'notistack';

interface IConferenceSignupPayload {
  conferenceId: string;
  firstName: string;
  lastName: string;
  email: string;
  conferenceCode: string;
  termsAndConditionsAccepted: boolean;
}

const baseClient = axios.create({ baseURL: import.meta.env.VITE_API_BASE_URL as string });

export const useConferenceSignup = () => {
  return useMutation({
    mutationFn: async ({ conferenceId, ...body }: IConferenceSignupPayload) => {
      await baseClient.post(`/conference/${conferenceId}/user/signup`, body);
    },
    onError: () => {
      enqueueSnackbar('Signup failed. Please check your details and try again.', { variant: 'error' });
    },
  });
};
